class CustomImageTextCarouselComponent extends HTMLElement {
  connectedCallback() {
    if (typeof Splide !== 'undefined') {
      this.initPages();
    } else {
      window.addEventListener('wnw_load', () => this.initPages(), { once: true });
    }
  }

  initPages() {
    var bannerSplide = new Splide(this.querySelector('.splide'), {
      type: 'loop',
      pagination : false,
      perPage: 1,
    });
    var $this = this;
    bannerSplide.on( 'mounted move', function () {
      $this.querySelector('.count .num').innerHTML = bannerSplide.index + 1
    });
    bannerSplide.mount();
    this.querySelectorAll('.splide .button').forEach(button => {
      button.addEventListener('click', function (e) {
        if (button.getAttribute('href') == '#next' ) {
          e.preventDefault();
          console.log(bannerSplide.index)
          var nextIndex = bannerSplide.index + 1;
          bannerSplide.go(nextIndex)
        }
      })
      
    });
  }
}

customElements.define('image-text-slide', CustomImageTextCarouselComponent);